import { Chip } from '@mui/material';

export const analyticsTableHeader = [
  {
    field: 'slNo',
    headerName: 'SL.No',
    width: 90,
    headerAlign: 'left',
    align: 'left',
  },
  {
    field: 'batchNames',
    headerName: 'Batch ID',
    width: 140,
    headerAlign: 'left',
    align: 'left',
  },
  {
    field: 'full_name',
    headerName: 'Name',
    width: 180,
    headerAlign: 'left',
    align: 'left',
  },
  {
    field: 'projectNames',
    headerName: 'Project',
    width: 180,
    headerAlign: 'left',
    align: 'left',
  },
  {
    field: 'courseNames',
    headerName: 'Course',
    width: 200,
    headerAlign: 'left',
    align: 'left',
  },
  {
    field: 'status',
    headerName: 'Status',
    width: 160,
    headerAlign: 'left',
    align: 'left',
    renderCell: ({ value, row }) => {
      let obj = {
        color: '',
      };

      switch (value) {
        case 'intern':
          obj.color = 'primary';
          break;
        case 'tutor':
          obj.color = 'success';
          break;
        case 'rejected':
          obj.color = 'error';
          break;

        default:
          obj.color = 'warning';
      }
      return (
        <Chip
          variant="outlined"
          sx={{
            textTransform: 'capitalize',
          }}
          label={row?.status ?? 'Pending'}
          color={obj.color}
        />
      );
    },
  },
  /* {
    field: 'feedback',
    headerName: 'Feedback',
    width: 220,
    headerAlign: 'left',
    align: 'left',
  }, */
];
